import { Controller } from '../utils/controller';

export default class extends Controller {
  static targets = [
    'button',
    'content',
    'faqButton',
    'faqSection',
    'plusIcon',
    'minusIcon',
    'sectionPlusIcon',
    'sectionMinusIcon'
  ];
  static requiredTargets = [];

  // TARGETS
  declare buttonTargets: HTMLButtonElement[];
  declare contentTargets: HTMLDivElement[];
  declare plusIconTargets: HTMLElement[];
  declare minusIconTargets: HTMLElement[];
  declare sectionPlusIconTarget: HTMLElement;
  declare sectionMinusIconTarget: HTMLElement;
  declare faqButtonTarget: HTMLDivElement;
  declare faqSectionTarget: HTMLDivElement;

  toggle(e: Event) {
    const index = Number((e.currentTarget as HTMLElement).dataset.index);

    if (this.contentTargets[index].ariaHidden === 'true') {
      this.plusIconTargets[index].classList.add('hidden');
      this.minusIconTargets[index].classList.remove('hidden');

      this.contentTargets[index].ariaHidden = 'false';
      this.buttonTargets[index].ariaExpanded = 'true';
    } else {
      this.plusIconTargets[index].classList.remove('hidden');
      this.minusIconTargets[index].classList.add('hidden');

      this.contentTargets[index].ariaHidden = 'true';
      this.buttonTargets[index].ariaExpanded = 'false';
    }

    this.contentTargets[index].classList.toggle('hidden');
  }

  sectionToggle() {
    this.faqSectionTarget.classList.toggle('hidden');

    if (this.faqSectionTarget.ariaHidden === 'true') {
      this.sectionPlusIconTarget.classList.add('hidden');
      this.sectionMinusIconTarget.classList.remove('hidden');

      this.faqSectionTarget.ariaHidden = 'false';
      this.faqButtonTarget.ariaExpanded = 'true';
    } else {
      this.sectionPlusIconTarget.classList.remove('hidden');
      this.sectionMinusIconTarget.classList.add('hidden');

      this.faqSectionTarget.ariaHidden = 'true';
      this.faqButtonTarget.ariaExpanded = 'false';
    }
  }
}
